import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { name: 'About', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Case Results', path: '/case-results' },
  { name: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="sticky top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="max-w-content mx-auto px-6">
        <div className="flex items-center justify-between h-18">
          {/* Logo */}
          <Link to="/" className="flex items-center py-2">
            <span className="font-serif text-xl font-semibold text-slate-900">Todd Sexton
              <span
                className="text-xs text-slate-500 block font-sans font-normal"
                style={{
                  fontWeight: "bold"
                }}>Deathcare Operations Management & Optimization</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-base font-medium ${
                  location.pathname === link.path
                    ? 'text-slate-900'
                    : 'text-slate-600 hover:text-slate-900'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://api.leadconnectorhq.com/widget/bookings/todd-sexton-black-swan-consulting"
              className="bg-accent-600 text-white text-base font-medium px-5 py-2.5 rounded-sm hover:bg-accent-500"
            >
              Private Consultation
            </a>
          </div>

          {/* Mobile Hamburger Button - Hidden on mobile, shown on md+ */}
          <button
            className="hidden md:block p-2 text-slate-900 hover:bg-gray-100 rounded-md"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Dropdown Menu - Only on md+ screens */}
        {isOpen && (
          <div className="hidden md:block bg-white border-t border-gray-100 py-4">
            <div className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`text-base font-medium px-4 py-3 ${
                    location.pathname === link.path
                      ? 'text-slate-900 bg-gray-50'
                      : 'text-slate-600 hover:bg-gray-50'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/contact"
                className="bg-accent-600 text-white text-center text-base font-medium mx-4 py-3 rounded-sm hover:bg-accent-500"
                onClick={() => setIsOpen(false)}
              >
                Private Consultation
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
